/**
 * 공통 헤더
 * https://www.figma.com/file/VnJWFW7CQnDri5lKEDc9Ol/NEXT_%EC%B5%9C%EC%A2%85-%EC%B7%A8%ED%95%A9_APP%26WEB?node-id=3504%3A365533
 */
export enum CommonMobileHeaderType {
  MainAndSub = 'MainAndSub',
  TwoDepth = 'TwoDepth',
  ThreeDepth = 'ThreeDepth',
  FourDepth = 'FourDepth',
  My = 'My',
  Cash = 'Cash',
}

/**
 * 예외 헤더
 * https://www.figma.com/file/VnJWFW7CQnDri5lKEDc9Ol/NEXT_%EC%B5%9C%EC%A2%85-%EC%B7%A8%ED%95%A9_APP%26WEB?node-id=3504%3A365545
 */
export enum ExceptionMobileHeaderType {
  Search = 'Search',
  ContentHome = 'ContentHome',
  MobileViewer = 'MobileViewer',
  NewWindow = 'NewWindow',
  NewWindowTwoDepth = 'NewWindowTwoDepth',
  Comment = 'Comment',
  Register = 'Register',
  UserLoginAgreement = 'UserLoginAgreement',
  SetOverview = 'SetOverview',
  GlobalAuth = 'GlobalAuth',
}

export const MOBILE_HEADER_HEIGHT_PX = 56;
export const PC_HEADER_HEIGHT_PX = 96;
export const MOBILE_CONTENT_HOME_HEADER_ID = 'mobile-content-home-header';
export const MOBILE_CONTENT_HOME_HEADER_ICON_CLASSNAME =
  'mobile-content-home-header-icon';
